import { normalizeAssetTypeName } from '../constants/filterableAssetTypes';
import { assetRecordAssetTypeId } from './homeCarouselAssetMatch';

/** Known Parking Garage type ids when the catalog exposes them. */
const PARKING_TYPE_IDS = new Set([
  10, // common Parking Garage id in Offizz catalogs
]);

const PARKING_TYPE_LABELS = new Set(
  ['Parking Garage', 'Parking', 'Car Park', 'חניון'].map((label) => normalizeAssetTypeName(label)),
);

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

function assetTypeNameBag(asset: Record<string, unknown>): Set<string> {
  const bag = new Set<string>();
  const add = (raw: unknown) => {
    if (typeof raw === 'string' && raw.trim()) {
      bag.add(normalizeAssetTypeName(raw));
    }
  };
  add(asset.asset_type_name);
  add(asset.assetTypeName);
  add(asset.type_name);
  add(asset.type);
  if (typeof asset.asset_type === 'string') {
    add(asset.asset_type);
  }
  if (isPlainObject(asset.asset_type)) {
    add(asset.asset_type.name);
    add(asset.asset_type.label);
    add(asset.asset_type.type_name);
    add(asset.asset_type.title);
  }
  return bag;
}

/** Whether a booking targets a parking garage (profile vehicle_id required). */
export function assetIsParkingBooking(asset: Record<string, unknown>): boolean {
  const typeId = assetRecordAssetTypeId(asset);
  if (typeId !== null && PARKING_TYPE_IDS.has(typeId)) {
    return true;
  }
  return Array.from(assetTypeNameBag(asset)).some(
    (name) =>
      PARKING_TYPE_LABELS.has(name) ||
      name.includes('parking') ||
      name.includes('חניון') ||
      name.includes('חני'),
  );
}
